<template>
  <div class="sidebar-user" @click="toggleTheme">
    <s-button :color="color" :icon="icon" variant="icon" />

    <transition>
      <div class="sidebar-user-text" v-if="drawer">
        Alterar Tema
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>

import { useThemeStore } from '~/store/theme';

const themeStore = useThemeStore();

themeStore.init();

const { current } = storeToRefs(themeStore);

interface ThemeProps {
  drawer: boolean;
}

const props = defineProps<ThemeProps>();

const toggleTheme = () => themeStore.toggle();

const icon = computed(() => current.value === 'light' ? 'mdiWeatherSunny' : 'mdiWeatherNight');

const color = computed(() => current.value === 'light' ? 'secondary' : 'primary');


</script>

<style>

</style>